import ICountry from '@/interfaces/countries/ICountry';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'CountryForm'
})
export default class CountryForm extends Vue {
    @Prop(Object) private countryData!: ICountry;
    @Prop(Boolean) private isEdit!: boolean;

    private get form():ICountry {
        return this.countryData;
    }

    private get isCreateForm() {
        return this.$route.name === 'country_create';
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    private get disabledForm() {
        return !(this.form.name.trim().length > 0 && this.form.heartbeatName.trim().length > 0 && this.form.code.trim().length > 0);
    }

    private sendForm() {
        if (this.disabledForm) {
            return false; 
        }
        this.isCreateForm ? this.$emit('createCountry', {
            name: this.form.name,
            code: this.form.code,
            heartbeatName: this.form.heartbeatName
        }) : this.$emit('updateCountry', {
            id: this.form.id,
            name: this.form.name,
            code: this.form.code,
            heartbeatName: this.form.heartbeatName
        })
    }


    private cancelForm() {
        this.$router.go(-1);
    }
}
